import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { Trophy } from "lucide-react";

const RANK_TONE = ["text-amber-500", "text-slate-400", "text-amber-700"];

export const Leaderboard = ({ rows }) => {
  const active = rows.filter((r) => r.claimed || r.finished || r.put_up || r.holding);
  const idle = rows.filter((r) => !(r.claimed || r.finished || r.put_up || r.holding));

  return (
    <div className="space-y-5" data-testid="leaderboard">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-10"></TableHead>
            <TableHead>Staff</TableHead>
            <TableHead className="text-right">Claimed</TableHead>
            <TableHead className="text-right">Finished</TableHead>
            <TableHead className="text-right">Avg days</TableHead>
            <TableHead className="text-right">Handed back</TableHead>
            <TableHead className="text-right">Put up</TableHead>
            <TableHead className="text-right">Holding</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {active.map((r, idx) => (
            <TableRow key={r.user_id} data-testid={`leaderboard-row-${r.user_id}`}>
              <TableCell className="text-center">
                {idx < 3 ? (
                  <Trophy size={14} className={RANK_TONE[idx]} />
                ) : (
                  <span className="text-xs text-muted-foreground tabular-nums">{idx + 1}</span>
                )}
              </TableCell>
              <TableCell>
                <span className="font-medium">{r.name}</span>
                {r.position && <span className="text-xs text-muted-foreground ml-2">{r.position}</span>}
              </TableCell>
              <TableCell className="text-right tabular-nums">{r.claimed}</TableCell>
              <TableCell className="text-right tabular-nums font-semibold">{r.finished}</TableCell>
              <TableCell className="text-right tabular-nums text-muted-foreground">
                {r.avg_days_to_finish ?? "—"}
              </TableCell>
              <TableCell className="text-right tabular-nums text-muted-foreground">{r.handed_back}</TableCell>
              <TableCell className="text-right tabular-nums text-muted-foreground">{r.put_up}</TableCell>
              <TableCell className="text-right tabular-nums">{r.holding}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {active.length === 0 && (
        <p className="text-sm text-muted-foreground py-8 text-center" data-testid="leaderboard-empty">
          Nothing claimed or finished in this window yet.
        </p>
      )}
      {idle.length > 0 && (
        <p className="text-xs text-muted-foreground" data-testid="leaderboard-idle">
          No shelf activity this period: {idle.map((r) => r.name).join(", ")}
        </p>
      )}
    </div>
  );
};
